import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import { errorToast } from 'Common/ToastHelper';
import { Filter, Main } from 'Containers';
import { NotificationDialog } from 'Components';
import { resetForm, submitForm } from 'State/forms/actions';
import { clearGridPreference } from 'State/gridPreference/actions';
import { ON_HAND_REPORT_FIFO_FORM_NAME } from 'Common/FormEnum';
import {
  OnHandReportFifoEnum,
  OnHandReportListingEnum,
} from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_SERVER } from 'Common/Constants';
import {
  GenericEnum,
  PrintGroupByTypeEnum,
} from 'Common/Constants/Enumeration/CommonEnum';
import { clearGridPreferenceSubmitError } from 'State/gridPreference/actions';
import { resetDirty } from 'State/dirtyTracking/actions';
import { clearTableSavedState } from 'Common/FormHelper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { setTableStates } from 'Common/UserSettings/state/actions';
import { getTableStates } from 'Common/UserSettings/helpers/helper';
import * as GridPreferenceSelectors from 'State/gridPreference/selectors';
import { ReportGeneration } from 'Common/ObjectHelper';

import { FIFOReportContainer } from './FIFOReport';
import { BASE_URL, INITIAL_VALUES } from '../../helper/fifo';
import { getOnHandFIFOItems, clearReportError } from '../../state/actions';
import {
  printReportData,
  clearPrintReportError,
  resetPrintResponse,
} from '../../../commonState/actions';
import { PRINT_API_URL } from '../../helper/onHand';
import * as OnHandListingSelectors from '../../state/selectors';
import * as CommonPrintSelector from '../../../commonState/selectors';

class FIFOReport extends Component {
  static propTypes = {
    submitForm: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    clearGridPreference: PropTypes.func.isRequired,
    getOnHandFIFOItems: PropTypes.func.isRequired,
    printReportData: PropTypes.func.isRequired,
    resetPrintResponse: PropTypes.func.isRequired,
    clearReportError: PropTypes.func.isRequired,
    clearPrintReportError: PropTypes.func.isRequired,
    clearGridPreferenceSubmitError: PropTypes.func.isRequired,
    resetDirty: PropTypes.func.isRequired,
    setTableStates: PropTypes.func.isRequired,
    selectedFifoSitesItems: PropTypes.object.isRequired,
    loadingOnHandFifoItemsError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    printLoading: PropTypes.bool.isRequired,
    allTableStates: PropTypes.object.isRequired,
    printError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    emptyPrintResponse: PropTypes.string,
    preferenceJsonError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    gridPreferenceSubmitError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
  };

  static defaultProps = {
    printError: null,
    emptyPrintResponse: null,
    preferenceJsonError: null,
    gridPreferenceSubmitError: null,
  };

  static path = `${BASE_URL}/fifo`;

  componentDidMount() {
    const { getOnHandFIFOItems, selectedFifoSitesItems } = this.props;
    selectedFifoSitesItems &&
    selectedFifoSitesItems[OnHandReportFifoEnum.ItemIds] &&
    selectedFifoSitesItems[OnHandReportFifoEnum.ItemIds].length &&
    selectedFifoSitesItems[OnHandReportFifoEnum.SiteIds] &&
    selectedFifoSitesItems[OnHandReportFifoEnum.SiteIds].length
      ? getOnHandFIFOItems({
          ...selectedFifoSitesItems,
          ShowAllDates: true,
        })
      : this.props.history.push(BASE_URL);
    this.props.resetDirty();
  }

  componentDidUpdate(prevProps) {
    const {
      clearReportError,
      clearGridPreferenceSubmitError,
      clearPrintReportError,
      printData,
    } = this.props;

    if (
      errorToast(this.props, prevProps, 'loadingOnHandFifoItemsError') ||
      errorToast(this.props, prevProps, 'preferenceJsonError') ||
      errorToast(this.props, prevProps, 'printError') ||
      errorToast(this.props, prevProps, 'gridPreferenceSubmitError')
    ) {
      clearPrintReportError();
      clearGridPreferenceSubmitError();
      clearReportError();
    }
    if (printData && printData !== prevProps.printData) {
      ReportGeneration(printData, 'On Hand FIFO Report');
      clearPrintReportError();
    }
  }

  componentWillUnmount() {
    this.clearTableSavedState();
  }

  clearTableSavedState = () => {
    const { history, allTableStates, setTableStates } = this.props;
    clearTableSavedState(history, BASE_URL, allTableStates, setTableStates, [
      TableNamesEnum.ON_HAND_REPORT_SITE_GRID_TABLE,
      TableNamesEnum.ON_HAND_REPORT_ITEM_GRID_TABLE,
      TableNamesEnum.ON_HAND_REPORT_FIFO_TABLE,
      TableNamesEnum.ON_HAND_REPORT_TRANSACTION_DETAILS_TABLE,
    ]);
  };

  getMainProps = () => {
    return {
      toolbox: {
        backButtonProps: { shown: true, path: `${BASE_URL}` },
        rightButtons: [
          {
            content: 'Print',
            onClick: this.handleClickPrint,
            loading: this.props.printLoading,
          },
        ],
        shown: true,
      },
    };
  };

  getBreadCrumbs = () => {
    return [
      {
        title: 'Reports | On Hand',
        link: `${BASE_URL}`,
      },
      {
        title: 'FIFO',
        link: '',
      },
    ];
  };
  handleClickPrint = () => {
    this.props.submitForm(ON_HAND_REPORT_FIFO_FORM_NAME);
  };

  handleSubmit = values => {
    const input = {
      [OnHandReportListingEnum.LoadFIFORequestModel]: {
        [OnHandReportFifoEnum.ItemIds]: values[OnHandReportFifoEnum.ItemIds],
        [OnHandReportFifoEnum.SiteIds]: values[OnHandReportFifoEnum.SiteIds],
        [OnHandReportFifoEnum.ShowAllDates]:
          values[OnHandReportFifoEnum.ShowAllDates],
      },
      [OnHandReportListingEnum.SortBy]:
        values[OnHandReportFifoEnum.PrintOptions],
    };
    if (!values[OnHandReportFifoEnum.ShowAllDates]) {
      input[OnHandReportListingEnum.LoadFIFORequestModel][
        OnHandReportFifoEnum.FromDt
      ] = moment(values[OnHandReportFifoEnum.FromDt]).format(
        DATE_FORMAT_FOR_SERVER
      );
      input[OnHandReportListingEnum.LoadFIFORequestModel][
        OnHandReportFifoEnum.ToDt
      ] = moment(values[OnHandReportFifoEnum.ToDt]).format(
        DATE_FORMAT_FOR_SERVER
      );
    }
    this.props.printReportData(PRINT_API_URL, input);
  };
  handleNoDataDialog = () => {
    const { emptyPrintResponse, resetPrintResponse } = this.props;
    emptyPrintResponse === GenericEnum.EmptyString && resetPrintResponse();
  };

  render() {
    const { selectedFifoSitesItems, emptyPrintResponse } = this.props;
    return (
      <Fragment>
        <Filter
          title={''}
          breadcrumbs={this.getBreadCrumbs()}
          style={{
            width: 400,
          }}
        />
        <Main {...this.getMainProps()} shouldNotUsePageWidth>
          <FIFOReportContainer
            onSubmit={this.handleSubmit}
            handleClickPrint={this.handleClickPrint}
            initialValues={{
              ...INITIAL_VALUES,
              ...selectedFifoSitesItems,
              [OnHandReportFifoEnum.PrintOptions]: PrintGroupByTypeEnum.Item,
            }}
          />
        </Main>
        <NotificationDialog
          title={'Print Report'}
          showDialog={emptyPrintResponse === GenericEnum.EmptyString}
          message={'No data available.'}
          onOkClick={this.handleNoDataDialog}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedFifoSitesItems: OnHandListingSelectors.getSelectedFifoSitesItems(
      state
    ),
    loadingOnHandFifoItemsError: OnHandListingSelectors.getLoadingOnHandFifoItemsError(
      state
    ),
    printLoading: CommonPrintSelector.getPrintLoading(state),
    printError: CommonPrintSelector.getPrintError(state),
    printData: CommonPrintSelector.getPrintData(state),
    emptyPrintResponse: CommonPrintSelector.getEmptyPrintResponse(state),
    preferenceJsonError: GridPreferenceSelectors.getPreferenceJsonError(state),
    gridPreferenceSubmitError: GridPreferenceSelectors.getSubmitError(state),
    allTableStates: getTableStates(state),
  };
};

const mapDispatchToProps = {
  submitForm,
  resetForm,
  clearGridPreference,
  getOnHandFIFOItems,
  printReportData,
  resetPrintResponse,
  clearReportError,
  clearPrintReportError,
  clearGridPreferenceSubmitError,
  resetDirty,
  setTableStates,
};

export const FIFOReports = connect(
  mapStateToProps,
  mapDispatchToProps
)(FIFOReport);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/onhandreport/containers/fiforeport/FIFOReportContainer.js